import React, { useState, useEffect,useCallback } from 'react'
import { GENERIC_REQUEST, LIST, WORKFLOW, getApiPath } from '../../api/ApiConst';
import TableFilter from '../constants/TableFilter';
import { useClient } from '../../config/ClientProvider';
import { useNavigate } from 'react-router-dom';
const WorkflowList = () => {
    const { selectedClient } = useClient();
    const [requestDrawCount, setRequestDrawCount] = useState(0);
    const navigate = useNavigate();

    // Refresh Table
    const refreshRequestTable = () => {
        setRequestDrawCount((pre) => (pre + 1));
    }

    const getRequestTableView = useCallback(() => {
        return (
            <>
                <div className='row justify-content-end'>
                    <div className="col-12 px-0">
                        <div className='card'>
                            <div className="card-body d-flex justify-content-end" style={{ textAlign: "right" }}>
                                <button className="btn btn-primary"
                                    onClick={() => navigate('/workflow/create')}> Create New</button>
                            </div>
                            <TableFilter
                                tableName="request"
                                tableUrl={getApiPath(WORKFLOW, LIST)}
                                paginationStatus={true}
                                drawCount={requestDrawCount}
                                refreshTableData={refreshRequestTable}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    },
        [requestDrawCount],
    );

    // useEffect to listen for selectedClient changes
	useEffect(() => {
		if (selectedClient) {
			refreshRequestTable();
		}
	}, [selectedClient]);

    return (
        <>
            {getRequestTableView()}
        </>
    )
}

export default WorkflowList
